import { Layout } from '@facile-it/shark-morph/components'
import * as React from 'react'
import { useDeviceLayout } from '../../../../../shark-lib/ts/services/Layout/layoutContext'
import { Footer } from '../../blocks/footer'
import { Header } from '../../blocks/header'
import { BecomePartner } from './components/becomePartner'

// TODO_LANDING_CLEANING
// - rimuovere varie immagini (icone compagnia e altre)
export const CreateProspect: React.FC = () => {
    const deviceLayout = useDeviceLayout()

    return (
        <Layout
            maxWidth={[
                {
                    type: 'low',
                    maxWidth: 1280,
                    minResolution: 1440,
                },
                {
                    type: 'max',
                    maxResolution: 1439,
                    maxWidth: 1024,
                },
            ]}
        >
            <Layout.Header borderless fixed={false}>
                <Header deviceLayout={deviceLayout} />
            </Layout.Header>
            <Layout.Content>
                <BecomePartner />
            </Layout.Content>
            <Layout.Footer>
                <Footer />
            </Layout.Footer>
        </Layout>
    )
}
